









































































































































































import Vue, { PropType } from "vue";
import moment from "moment";
import { mapGetters } from "vuex";
import { formatSeconds } from "@/utility/Formatter";

//Component
import InsertClosingCodeDialog from "./InsertClosingCodeDialog.vue";
import DateMomentTooltip from "@/components/DateMomentTooltip.vue";
import ConfirmSmartLockEnablingDialog from "./ConfirmSmartLockEnablingDialog.vue";
import SmartLockEventsHistoryCard from "./SmartLockEventsHistoryCard.vue";

// Model
import { InstallationSmartLockStatus } from "@/model/data/oneTimeCode/InstallationSmartLockStatus";
import { GenerateSmartLockChallengeCommand } from "@/model/communication/oneTimeCode/GenerateSmartLockChallegeCommand";
import { GenerateSmartLockChallengeResData } from "@/model/communication/oneTimeCode/GenerateSmartLockChallengeResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { Machine } from "@/model/data/Machine";
import { SmartLockInternalState } from "@/model/data/enums/SmartLockInternalStateEnum";
import { GetSmartLockNonceResData } from "@/model/communication/oneTimeCode/GetSmartLockNonceResData";
import { GetSmartLockNonceCommand } from "@/model/communication/oneTimeCode/GetSmartLockNonceCommand";
import { EnableSmartLockCommand } from "@/model/communication/oneTimeCode/EnableSmartLockCommand";
import { InsertSmartLockClosingCodeResData } from "@/model/communication/oneTimeCode/InsertSmartLockClosingCodeResData";
import { InsertSmartLockClosingCodeCommand } from "@/model/communication/oneTimeCode/InsertSmartLockClosingCodeCommand";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";

export default Vue.extend({
    components: { InsertClosingCodeDialog, DateMomentTooltip, ConfirmSmartLockEnablingDialog, SmartLockEventsHistoryCard },
    props: {
        installation: Object as PropType<InstallationSmartLockStatus>,
        machine: Object as PropType<Machine>,
        loading: Boolean,
    },
    data() {
        return {
            moment,
            onlyNumber: [(v) => /^\d+$/.test(v) || this.$t("smartLock.onlyNumber"), (v) => /^\d{8}$/.test(v) || this.$t("smartLock.8digit")],
            localInstallation: null,
            SmartLockInternalState,
            nonce: null,
            generateSmartLockChallengeLoading: false,
            challengeCode: null,
            canCopy: window.isSecureContext,
            copiedToClipboard: false,
            getNonceLoading: false,
            getNonceExecuted: false,
            countdownTimer: null,
            timerElement: null,
            showAlert: false,
            alertMessage: "",
            alertType: "",
            insertClosingCodeLoading: false,
            closingCode: null,
            enabled: false,
            showInsertClosingCodeDialog: false,
            lastNonceReceivedAt: null,
            showConfirmSmartLockEnabling: false,
        };
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),
        canGenerate() {
            if (this.nonce && /^\d{8}$/.test(this.nonce)) return true;
            return false;
        },
        machineSmartLock() {
            if (this.localInstallation && this.localInstallation.smartLocks && this.localInstallation.smartLocks.get(this.machine.serialNumber))
                return this.localInstallation.smartLocks.get(this.machine.serialNumber);
            return null;
        },
        codeValidity() {
            if (this.machineSmartLock && this.machineSmartLock.workModeOptions && this.machineSmartLock.workModeOptions.NonceValidityMS)
                return this.machineSmartLock.workModeOptions.NonceValidityMS / 60000;
            return 0;
        },
        openLockSessionDuration() {
            if (this.machineSmartLock && this.machineSmartLock.workModeOptions && this.machineSmartLock.workModeOptions.OpenLockSessionDurationMS)
                return this.machineSmartLock.workModeOptions.OpenLockSessionDurationMS / 60000;
            return 0;
        },
        operatingMode() {
            if (
                this.machineSmartLock &&
                this.machineSmartLock.workModeOptions &&
                this.machineSmartLock.workModeOptions.OperatingMode >= 0 &&
                this.machineSmartLock.workModeOptions.OperatingMode <= 1
            )
                return this.machineSmartLock.workModeOptions.OperatingMode;
            return -1;
        },
        timerEnabled() {
            return this.operatingMode == 1 && this.codeValidity > 0;
        },
        hasEnablingPrivilege() {
            return this.authUserHasPrivilege(ClientPrivileges.SmartLockManagement);
        },
    },
    watch: {
        installation: {
            handler(newVal) {
                this.localInstallation = newVal;
                if (this.hasEnablingPrivilege) this.sendRequestGetNonce();
                this.reset();
            },
            immediate: true,
            deep: true,
        },
        machineSmartLock: {
            handler(newVal) {
                this.enabled = newVal.manualAuthorized;
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        formatSeconds,
        reset() {
            this.showAlert = false;
            this.alertMessage = "";
            this.alertType = "";
            this.enabled = false;
        },
        generateSmartLockChallenge() {
            if (this.canGenerate) {
                this.sendGenerateSmartLockChallengeRequest();
            }
        },
        async sendGenerateSmartLockChallengeRequest() {
            try {
                this.showAlert = false;
                if (this.timerEnabled) this.resetTimer();
                this.generateSmartLockChallengeLoading = true;
                let response: GenerateSmartLockChallengeResData = await new GenerateSmartLockChallengeCommand(
                    this.installation.name,
                    this.machine.serialNumber,
                    this.nonce
                ).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success && response.challengeCode) {
                    this.challengeCode = response.challengeCode;
                    this.enabled = response.manualAuthorized;
                    if (this.timerEnabled) {
                        this.resetTimer();
                        this.runTimer(response.remainingSeconds);
                    }
                    if (!this.enabled) this.showConfirmSmartLockEnabling = true;
                } else {
                    throw response.message;
                }
            } catch (error) {
                switch (error) {
                    case CReqExecutionResultEnum.ServerError:
                        this.alertMessage = this.$t("smartLock.genericErrorGenerating");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.InvalidRequest:
                        this.alertMessage = this.$t("smartLock.invalidNonce");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.LicenseExpired:
                        this.alertMessage = this.$t("smartLock.noLicense");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.OperationNotAvailable:
                        this.alertMessage = this.$t("smartLock.smartLockNotFound");
                        this.alertType = "error";
                        break;
                    default:
                        console.error("Something went wrong sending GenerateSmartLockChallenge request ", error);
                        this.alertMessage = this.$t("smartLock.genericErrorGenerating");
                        this.alertType = "error";
                        break;
                }
                this.showAlert = true;
            }
            this.generateSmartLockChallengeLoading = false;
        },
        smartLockEnabled() {
            this.sendSmartLockEnabledRequest();
        },
        async sendSmartLockEnabledRequest() {
            try {
                this.generateSmartLockChallengeLoading = true;
                this.showAlert = false;
                let response: ApiGenericResponse = await new EnableSmartLockCommand(this.installation.name, this.machine.serialNumber).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.message == "") {
                    this.enabled = true;
                } else {
                    throw response.message;
                }
            } catch (error) {
                switch (error) {
                    case CReqExecutionResultEnum.ServerError:
                        this.alertMessage = this.$t("smartLock.genericErrorEnabling");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.LicenseExpired:
                        this.alertMessage = this.$t("smartLock.noLicense");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.OperationNotAvailable:
                        this.alertMessage = this.$t("smartLock.smartLockNotFound");
                        this.alertType = "error";
                        break;
                    default:
                        console.error("Something went wrong sending EnableSmartLock request ", error);
                        this.alertMessage = this.$t("smartLock.genericErrorEnabling");
                        this.alertType = "error";
                        break;
                }
                this.showAlert = true;
            }
            this.generateSmartLockChallengeLoading = false;
        },
        async copyChallengeCode() {
            await navigator.clipboard.writeText(this.challengeCode);
            this.copiedToClipboard = true;
            setTimeout(() => {
                this.copiedToClipboard = false;
            }, 1500);
        },
        async getNonce() {
            await this.sendRequestGetNonce();
            this.getNonceExecuted = true;
            setTimeout(() => {
                this.getNonceExecuted = false;
            }, 1500);
        },
        async sendRequestGetNonce() {
            try {
                this.getNonceLoading = true;
                let response: GetSmartLockNonceResData = await new GetSmartLockNonceCommand(this.installation.name, this.machine.serialNumber).execute();

                if (
                    response.responseStatus == ApiResponseStatusEnum.Success &&
                    response.nonce &&
                    ((this.operatingMode == 1 && response.remainingSeconds) || this.operatingMode == 0)
                ) {
                    this.nonce = response.nonce;
                    if (response.challengeCode) this.challengeCode = response.challengeCode;
                    if (response.lastNonceReceivedAt) this.lastNonceReceivedAt = response.lastNonceReceivedAt;
                    if (this.timerEnabled) {
                        this.resetTimer();
                        this.runTimer(response.remainingSeconds);
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending OpenSmartLock request ", e);
            }
            this.getNonceLoading = false;
        },
        runTimer(timeRemaining) {
            const timerCircle = this.timerElement.querySelector("svg > circle + circle");
            this.timerElement.classList.add("animatable");
            timerCircle.style.strokeDashoffset = 1;
            let totalTime = this.codeValidity * 60;
            let formatSeconds = this.formatSeconds;
            let countdownTimerInternal = this.countdownTimer;
            let resetTimerInternal = this.resetTimer;
            this.countdownTimer = setInterval(function () {
                let timer = document.getElementById("timeLeftId");
                if (timeRemaining >= 1) {
                    timeRemaining--;
                    const normalizedTime = (totalTime - timeRemaining) / totalTime;
                    timerCircle.style.strokeDashoffset = normalizedTime;
                    timer.innerHTML = formatSeconds(timeRemaining, true, true);
                } else {
                    timer.innerHTML = "0";
                    resetTimerInternal(countdownTimerInternal);
                }
            }, 1000);
        },
        resetTimer() {
            clearInterval(this.countdownTimer);
            this.timerElement.classList.remove("animatable");
        },
        insertClosingCode(closingCode: string) {
            this.sendInsertSmartLockClosingCodeRequest(closingCode);
        },
        async sendInsertSmartLockClosingCodeRequest(closingCode: string) {
            try {
                this.insertClosingCodeLoading = true;
                let response: InsertSmartLockClosingCodeResData = await new InsertSmartLockClosingCodeCommand(
                    this.installation.name,
                    this.machine.serialNumber,
                    closingCode
                ).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.challengeCode) {
                    this.nonce = closingCode;
                    this.$refs.form.reset();
                    this.challengeCode = response.challengeCode;
                }
            } catch (e) {
                console.log("Something went wrong sending InsertSmartLockClosingCode request ", e);
            }
            this.insertClosingCodeLoading = false;
        },
    },
    mounted() {
        if (this.timerEnabled) this.timerElement = document.querySelector(".timer");
    },
});
